import React from "react";
import { FormSectionElements, FormSections, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { ConfirmDialog } from "primereact/confirmdialog";
import { Editor } from "primereact/editor";
import { InputTextarea } from "primereact/inputtextarea";
import { DialogforRadioOptions } from "./DialogforRadioOptions";
import { FR_SUFFIX } from "../../entities/Constants";
import Utils from "../../utilities/Utils";
import { DialogBase } from "./DialogBase";
import { LinkedDropdowns } from "./LinkedDropdowns";
import { findDependency, getRootComponent } from "../../utilities/ElementUtils";
import { removeHtmlTags } from "../../utilities/HtmlUtils";
import { renderSearchButtonConfig } from "../helpers/SearchFilterDialogHelpers";

interface Props {
    formSection: FormSections;
    ele: FormSectionElements;
    isEng: boolean;
    callback;
}
interface State {
    pickedFieldOptions;
    confirmVisible: boolean;
    deleteIndex: number;
    dialogVisibleForRadioOptions: boolean[];
    enableSearch: boolean;
}

export class DropdownDesignComponent extends DialogBase<Props,State> {
    constructor(props: Props) {
        super(props);

        const eleAny = this.props.ele as any;
        this.state = {
            pickedFieldOptions: [],
            confirmVisible: false,
            deleteIndex: -1,
            dialogVisibleForRadioOptions: [],
            enableSearch: eleAny.enableSearch || false,
        };
    }

    sectionAllFieldOptions=(listOfFormSubSections: FormSubSections[], elementListWithOptions:any[]) =>{
        if (!listOfFormSubSections) return;
      
        listOfFormSubSections.forEach((subSection) => {
            const list = subSection.ListOfFormSectionElements.filter((q) =>
              ["RadioButton", "CheckGroup", "Dropdown", "Row"].includes(q.Datatype)
            ).flatMap((q) => {
              if (q.Datatype === "Row") {
                this.sectionAllFieldOptions(q.subSectionList, elementListWithOptions);
                return elementListWithOptions; // Don't add anything for the Row itself
              } else {
                return elementListWithOptions.push(...[{
                  code: q.LoadBindName?.replace(/\s/g, ""),
                  description: this.props.isEng ? q.ENUTitle : q.FRATitle
                }]);
              }
            });
            //elementListWithOptions.push(...list);
          }
        )
    }

    dropdownHtml = () => {
        let p = this.props.ele;
        let elementListWithOptions = [];
        {/* @ts-ignore */}

        let listSubSections = this.props.formSection.ListOfFormSubSections 
        {/* @ts-ignore */}
        if(this.props.formSection?.Datatype==='Row'){
            listSubSections=this.props.formSection.parent.parent.ListOfFormSubSections
        }
        if (listSubSections != null) {
            this.sectionAllFieldOptions(listSubSections,elementListWithOptions)
            elementListWithOptions=elementListWithOptions.filter(item => item.code !== p.LoadBindName)

        }
        elementListWithOptions.unshift({code:'',description:'Please select one'})
        let htmlString = [];

        if (p.ListOfLOVValues == null) {
            p.ListOfLOVValues = [];
        }

        if (p.ListOfLOVValues.length === 0) {
            let lov = new LOVValues();
            lov.parent=p;
            p.ListOfLOVValues.push(lov);
            //console.log(lov);
        }

        p.ListOfLOVValues.forEach((lov: LOVValues, index) => {
            htmlString.push(
                <div
                    style={{
                        width: "100%",
                        display: "flex",
                        justifyContent: "space-between",
                        paddingTop: "5px",
                        alignItems: "center"
                    }}
                    key={"option_" + index}>


                    <div style={{
                        width: "90%",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center"
                    }}>


                    <div style={{ marginRight: "5px" }}>{index + 1}</div>
                    <div>
                        <i className="fa fa-regular fa-circle-dot"></i>
                    </div>
                    <div style={{ flex: "1 1 30%", marginRight: "5px", minWidth: "50px"}}>
                        {!p.displayAsRichText && (<InputText
                            className="ontario-input"
                            placeholder={"Option " + (index + 1).toString()}
                            value={this.props.isEng ? lov.description : lov.FRADescription}
                            onChange={(e) => {
                                let message = findDependency(getRootComponent(this.props.ele), p.LoadBindName);
                                if (this.props.isEng) {
                                   
                                        if (Utils.willDefaultFR(lov.description, lov.FRADescription)) {
                                            lov.FRADescription = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                        }
                                        lov.code = e.target.value;
                                        lov.description = e.target.value;
                                        this.props.callback();
                                    
                                } else {
                                    lov.FRADescription = e.target.value;
                                    this.props.callback();
                                }
                            }}
                        ></InputText>)}

                        {p.displayAsRichText && p.displayInEditor && <Editor value={this.props.isEng ? lov.richText : lov.richTextFRA}
                            onTextChange={(e) => {
                                if (this.props.isEng) {
                                    if (Utils.willDefaultFR(p.Value, p.ValueFRA)) {
                                        lov.richTextFRA = Utils.isNullOrEmpty(e.htmlValue) ? '' : e.htmlValue + FR_SUFFIX;
                                    }
                                    lov.code = removeHtmlTags(e.htmlValue);  // Code should not cotain HTML tags
                                    lov.richText = e.htmlValue
                                } else {
                                    lov.FRA = removeHtmlTags(e.htmlValue);  // Code should not cotain HTML tags
                                    lov.richTextFRA = e.htmlValue;
                                }
                                this.props.callback();
                            }}
                            style={{ height: 'auto' }}
                        />
                        }
                        {p.displayAsRichText && !p.displayInEditor && <InputTextarea value={this.props.isEng ? lov.richText : lov.richTextFRA} 
                            onChange={(e) => {
                                if (this.props.isEng) {
                                    if (Utils.willDefaultFR(p.Value, p.ValueFRA)) {
                                        lov.richTextFRA = Utils.isNullOrEmpty(e.target.value) ? '' : e.target.value + FR_SUFFIX;
                                    }
                                    lov.code = removeHtmlTags(e.target.value);  // Code should not cotain HTML tags
                                    lov.richText = e.target.value
                                } else {
                                    lov.FRA = removeHtmlTags(e.target.value);  // Code should not cotain HTML tags
                                    lov.richTextFRA = e.target.value
                                }
                                this.props.callback();
                            }} 
                            style={{ height: '100px', width: '100%' }} />
                        }
                    </div>

                        {/* Custom code value */}
                        <div style={{ flex: "1 2 30%", marginRight: "5px", minWidth: "50px"}}>
                            <InputText
                                className="ontario-input"
                                placeholder={"Custom value " + (index + 1).toString()}
                                value={this.props.isEng?lov.code:lov.FRA}
                                title={
                                    "Custom value " + (index + 1).toString() +
                                    (this.props.isEng
                                    ? (lov.code ? `: ${lov.code}` : "")
                                    : (lov.FRA ? `: ${lov.FRA}` : ""))
                                }
                                onChange={(e) => {
                                    if (this.props.isEng) {
                                        lov.code = e.target.value;
                                    } else {
                                        lov.FRA = e.target.value;
                                    }
                                    this.props.callback();
                                }}
                                onBlur={(e) => {
                                    if (!e.target.value) {
                                        if (this.props.isEng) {
                                            lov.code = lov.description;
                                        } else {
                                            lov.FRA = lov.FRADescription;
                                        }
                                        this.props.callback();
                                    }
                                }}
                            ></InputText>
                        </div>

                        <LinkedDropdowns formSection={this.props.formSection} lovs={lov} options={elementListWithOptions} callback={this.props.callback} />
                    </div>

                    <div style={{
                        width: "10%",
                        display: "flex",
                        justifyContent: "flex-end",
                        paddingTop: "7px",
                        alignItems: "center" }}>
                        {/* more option dialog only shows up for radio buttons, not dropdowns */}
                        {p.Datatype == "RadioButton" &&
                        <div style={{  marginTop: "2px", marginRight: "25%" }} key={`moreOptions_${lov.code}`}>
                            <i
                                title="More Options"
                                className="pi pi-ellipsis-v"
                                style={{ fontSize: "1rem", cursor: "pointer" }}
                                onClick={(e) => {
                                    this.state.dialogVisibleForRadioOptions[index] = true;
                                    this.setState({ dialogVisibleForRadioOptions: this.state.dialogVisibleForRadioOptions });
                                }}
                            />
                        </div>}

                        <div style={{ marginLeft: "10px" }}>
                            <i
                                title="Remove me"
                                className="pi pi-trash"
                                style={{ fontSize: "1rem", cursor: "pointer" }}
                                onClick={() => {
                                    this.setState({ confirmVisible: true, deleteIndex: index });
                                }}
                            ></i>
                        </div>
                    </div>
                </div>
            );

            htmlString.push(
                <div>
                    <DialogforRadioOptions
                        ele={lov}
                        dialogVisible={this.state.dialogVisibleForRadioOptions[index]}
                        isEng={this.props.isEng}
                        callback={(visible) => {
                            if (visible != null) {
                                this.state.dialogVisibleForRadioOptions[index] = false;
                                this.setState({ dialogVisibleForRadioOptions: this.state.dialogVisibleForRadioOptions });
                            }
                            this.props.callback();
                        }} />
                </div>
            )
        });

        if (p.displayAsRichText) {  // Single toggle button for all editors of this section-element.
            htmlString.push(
                <button 
                    onClick={() => {
                        p.displayInEditor = !p.displayInEditor;
                        this.props.callback();
                    }} >{p.displayInEditor == true ? "Raw" : "HTML"}
                </button>
            )            
        }

        htmlString.push(
            <div key={"addoption_" + p.Id}>
                {/* @ts-ignore */}
                <Button
                    className="p-button-rounded p-button-secondary"
                    style={{
                        cursor: "pointer",
                        margin: "5px",
                        fontSize: "90%",
                        border: "1px solid #64748B",
                        color: "#64748B",
                        background: "white"
                    }}
                    onClick={() => {
                        let newLov = new LOVValues();
                        newLov.Sequence = p.ListOfLOVValues.length;
                        newLov.parent=p;
                        p.ListOfLOVValues.push(newLov);
                        this.props.callback();
                    }}>
                    Add option
                </Button>
            </div>
        );

        const eleAny = p as any;
        htmlString.push(
            <div key={"searchconfig_" + p.Id} style={{ marginTop: '20px', paddingTop: '15px', borderTop: '1px solid #ddd' }}>
                {renderSearchButtonConfig(
                    p,
                    this.state.enableSearch,
                    (checked) => {
                        eleAny.enableSearch = checked;
                        if (!checked) eleAny.searchTargetSummaryListId = null;
                        this.setState({ enableSearch: checked });
                        this.props.callback();
                    },
                    this.props.isEng,
                    () => this.props.callback()
                )}
            </div>
        );

        return htmlString;
    };


    confirmRemove = () => {
        const { deleteIndex } = this.state;
        let p = this.props.ele;
        p.ListOfLOVValues.splice(deleteIndex, 1);
        this.props.callback();
        this.setState({ confirmVisible: false });
    };

    render() {
        return (
            <div>
                {this.dropdownHtml()}
                {/* @ts-ignore */}
                <ConfirmDialog
                    visible={this.state.confirmVisible}
                    onHide={() => this.setState({ confirmVisible: false })}
                    message="Are you sure you want to remove this?"
                    header="Confirmation"
                    icon="pi pi-exclamation-triangle"
                    accept={this.confirmRemove}
                    reject={() => this.setState({ confirmVisible: false })}
                    closable={false}
                />
            </div>
        );
    }
}
